// NAO MEXER NESTES HOOKS!!

import { useCallback, useEffect, useMemo } from "react"

import { useNode } from "@craftjs/core"
import { get, set } from "lodash"

export function useCraftProperty(name, defaultValue) {
  const { actions: { setProp }, value } = useNode(({ data: { props } }) => ({
    value: get(props, name),
  }))
  return useCraftAction(setProp, value, name, defaultValue)
}

export function useCraftCustom(name, defaultValue) {
  const { actions: { setCustom }, value } = useNode(({ data: { custom } }) => ({
    value: get(custom, name),
  }))
  return useCraftAction(setCustom, value, name, defaultValue)
}

function useCraftAction(setAction, value, name, defaultValue) {
  const setValue = useCallback(value => {
    setAction(props => {
      set(props, name, value)
    })
  }, [setAction, name])

  useEffect(() => {
    if (defaultValue !== undefined) {
      setValue(defaultValue)
    }
  }, [defaultValue, setValue])

  return useMemo(() => ({ value, setValue }), [value, setValue])
}
